import React from 'react';

class IE extends React.Component {
    render() {
        return (
            <div className="g-min-height-100vh g-flex-centered g-pa-15">
                <div className="text-center g-flex-centered-item g-position-rel g-pb-15">
                    <div className="g-font-size-120 g-font-size-200--sm g-line-height-1 g-font-weight-600er g-color-gray-light-v4">KARA</div>
                    <div className="g-absolute-centered">
                        <h1 className="h3 g-color-black g-mt-minus-8 mb-0">혹시 버전 10 미만인 오래된 인터넷 익스플로러를 사용하고 계신가요?</h1>
                        <hr className="g-brd-gray-light-v3 g-my-15" />
                        <p className="g-font-size-16">
                            카라 홈페이지를 편안하게 이용하시려면 IE 10 이상의 브라우저를 사용해 주세요.<br />
                            IE 10 이상으로 업데이트하지 않으실 경우 서비스를 원활하게 이용하실 수 없으니<br />
                            구 버전의 인터넷 익스플로러를 사용하고 계시다면 업데이트하시기 바랍니다.
			                </p>
                        <p className="g-font-size-16">
                            <a href="https://support.microsoft.com/ko-kr/help/17621/internet-explorer-downloads" target="_blink">[ 인터넷 익스플로러 다운로드하러 가기 ]</a><br />
                        </p>
                        <p className="g-font-size-16">
                            혹 다른 사정 때문에 IE 10 이상을 설치하기 어렵다면 크롬 브라우저를 사용해 주시기 바라며<br />
                            보안과 사용 편의성을 위해 어떤 브라우저를 사용하시든 늘 최신 버전을 유지해 주세요.
			            </p>
                        <p className="g-font-size-16">
                            <a href="https://www.google.co.kr/chrome/" target="_blink">[ 크롬 브라우저 다운로드하러 가기 ] </a><br />
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}

export default IE;


// WEBPACK FOOTER //
// ./src/pages/front/home/ie.js